"use strict";

/*globals Kobo*/

/**
 * FooterLanguageSelector
 * @description Handles the footer language selector dropdown functionality
 *
 * Usage:
 * <div class="footer-language-selector" data-kobo-gizmo="FooterLanguageSelector">
 *   <button class="footer-language-selector-button">...</button>
 *   <ul class="footer-language-selector-dropdown">...</ul>
 * </div>
 */
Kobo.Gizmo.FooterLanguageSelector = function () {
  'use strict';

  var self = this,
      init,
      openDropdown,
      closeDropdown,
      toggleDropdown,
      handleOutsideClick,
      $button,
      $dropdown;
  Kobo.Gizmo.apply(self, arguments);

  openDropdown = function openDropdown() {
    self.$el.addClass('expanded');
    $dropdown.addClass('open');
    $button.attr('aria-expanded', 'true');
  };

  closeDropdown = function closeDropdown() {
    self.$el.removeClass('expanded');
    $dropdown.removeClass('open');
    $button.attr('aria-expanded', 'false');
  };

  toggleDropdown = function toggleDropdown(e) {
    e.preventDefault();
    e.stopPropagation();

    if (self.$el.hasClass('expanded')) {
      closeDropdown();
    } else {
      openDropdown();
    }
  };

  handleOutsideClick = function handleOutsideClick(e) {
    if (!self.$el[0].contains(e.target)) {
      closeDropdown();
    }
  };

  self.destroy = function () {
    $button.off('click', toggleDropdown);
    Kobo.$(document).off('click', handleOutsideClick);
    $button = null;
    $dropdown = null;
  };

  init = function init() {
    $button = self.$el.find('.footer-language-selector-button');
    $dropdown = self.$el.find('.footer-language-selector-dropdown');

    if ($button.length === 0 || $dropdown.length === 0) {
      console.error('[Footer Language Selector] Required elements not found');
      return;
    } // Handle button click


    $button.on('click', toggleDropdown); // Close dropdown when clicking outside

    Kobo.$(document).on('click', handleOutsideClick);
  };

  init();
};

Kobo.Gizmo.FooterLanguageSelector.prototype = Kobo.chainPrototype(Kobo.Gizmo.prototype);